import './style.sass';
import { ReactSVG } from 'react-svg';
import React from 'react';
import closeIcon from 'assets/img/icons/close-icon.svg';
import { Form, Formik } from 'formik';
import { CampaignViewModel } from 'app/viewModels/components/CampaignViewModel';
import { InputGroup } from '../common/InputGroup';
import { Button } from '../common/Button';
import { updateCampaignInfoValidationSchema } from 'app/viewModels/pages/CampaignInnerPageViewModel';
import { createPortal } from 'react-dom';
import { Modal } from '../common/Modal';
import { FlagModel } from '@zajno/common-mobx/viewModels';
import { observer } from 'mobx-react-lite';
import { CampaignMainInfoUpdateData } from 'common/types/models/campaign';

type Props = {
    campaignModel: CampaignViewModel,
    isActiveModel: FlagModel,
    onSubmit: (data: CampaignMainInfoUpdateData) => void,
    isLoading: boolean,
};

export const UpdateCampaignInfo = observer(({ campaignModel, isActiveModel, onSubmit, isLoading }: Props) => {
    const { customerName, customerEmail, streams } = campaignModel;

    const initialValues = {
        name: customerName || '',
        email: customerEmail || '',
        guaranteedStream: streams || 0,
    };

    const onCloseModal = () => {
        isActiveModel.setFalse();
    };

    const onSubmitForm = (data: CampaignMainInfoUpdateData) => {
        if (onSubmit) {
            onSubmit(data);
        }
    };

    if (!isActiveModel.value) {
        return null;
    }

    return (
        createPortal(
            <Modal onClose={onCloseModal}>
                <div className="update-campaign-info">
                    <div className="update-campaign-info__close-btn" onClick={onCloseModal}>
                        <ReactSVG src={closeIcon}/>
                    </div>

                    <h1 className="title-h1 update-campaign-info__title">Edit main information</h1>

                    <Formik
                        initialValues={initialValues}
                        validationSchema={updateCampaignInfoValidationSchema}
                        onSubmit={onSubmitForm}
                        enableReinitialize
                    >
                        <Form className="update-campaign-info__form">
                            <InputGroup
                                id="mainInfoName"
                                name="name"
                                autoComplete="name"
                                label="Name"
                                placeholder="Campaign holder name"
                            />

                            <InputGroup
                                id="mainInfoEmail"
                                name="email"
                                autoComplete="email"
                                label="Email"
                                placeholder="Campaign holder email"
                            />

                            <InputGroup
                                id="mainInfoStreams"
                                name="guaranteedStream"
                                autoComplete="off"
                                label="Guaranteed Streams"
                                placeholder="Campaign stream goal"
                            />

                            <div className="update-campaign-info__buttons">
                                <Button
                                    className="update-campaign-info__cancel-btn"
                                    type="button"
                                    text="Cancel"
                                    size="big"
                                    colorType="primary-light"
                                    onClick={onCloseModal}
                                />

                                <Button
                                    className="update-campaign-info__save-btn"
                                    type="submit"
                                    text="Save changes"
                                    size="big"
                                    isLoading={isLoading}
                                />
                            </div>
                        </Form>
                    </Formik>
                </div>
            </Modal>,
            document.body,
        ) as React.ReactNode
    );
});
